import ApiService from "@/core/services/api.service";

const actions = {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  removeTeacherAdminRole(context, payload) {
    ApiService.setHeader();
    return ApiService.post(
      "school/employee/teacher/privilege/remove",
      payload
    ).then((response) => response);
  },
};

export default {
  actions,
};
